import { graphql } from "gatsby";
import React, { FC, useMemo } from "react";

import { TagColors } from "../../forms/elements/tags/types";
import { HeroBanner, HeroBannerProps } from "../../strips/hero-banner";
import { HeroBannerVariants, JustifyText } from "../../strips/hero-banner/types";
import { ExhibitionStripCard } from "./exhibition-strip-card";

export interface ExhibitionStripProps extends Queries.ExhibitionStripDataFragment {
  labels: Record<string, any>;
}

export const ExhibitionStrip: FC<ExhibitionStripProps> = ({
  title,
  materials,
  node_locale,
  bannerImage,
  description,
  labels,
  ...cardProps
}) => {
  const tags = useMemo(() => {
    const tags: HeroBannerProps["pillTags"] = Array.from(materials ?? [], (material) => ({
      color: material as TagColors,
      children: labels?.[material ?? ""],
    }));
    return tags;
  }, [labels, materials]);

  const customCard = <ExhibitionStripCard node_locale={node_locale} {...cardProps} />;

  return (
    <HeroBanner
      title={title}
      tagVariant={HeroBannerVariants.h1}
      media={bannerImage as HeroBannerProps["media"]}
      pillTags={tags}
      abstract={description}
      showBiesseLogo={false}
      color={null}
      padded={false}
      justifyText={JustifyText.LEFT}
      card={null}
      anchors={null}
      customCard={customCard}
    />
  );
};

export const query = graphql`
  fragment ExhibitionStripData on ContentfulExhibition {
    title
    materials
    startDate
    timeStart
    endDate
    timeEnd
    node_locale
    bannerImage {
      gatsbyImageData
      mimeType
    }
    description {
      text: description
    }
    defaultLocaleEntry {
      title
    }
    location
    address {
      raw
    }
    ticketPurchaseLink {
      ...CtaData
    }
  }
`;
